import { call, put, takeEvery } from 'redux-saga/effects';
import { sagaTypes } from './types';
import {
  getBrandAction,
  getBrandsAction,
  getMoreBrandsAction,
  getPublicBrandsAction,
  setSizePageAction,
} from './action';
import { IData, IDataPage } from '../../interfaces/common';
import { IBrand } from '../../interfaces/product';
import { IAction } from '../utils';
import { getBrand, getBrands, getBrandsData } from '../../api/brands';

// export function* getBrandsWorkerSaga({ payload }: IAction<number>) {
//   const res: { data: IBrand[] } = yield call(getBrands, payload);
//   yield put(getBrandAction(res?.data || []));
//   // if (res?.data) {
//   //   yield put(setSizePageAction(res.data.pageSize));
//   // }
// }

// export function* brandsWatcherSaga() {
//   yield takeEvery(sagaTypes.GET_ALL_BRANDS, getBrandsWorkerSaga);
// }

export function* getBrandsWorkerSaga({ payload }: IAction<string>) {
  const res: IDataPage<IBrand[]> = yield call(getBrandsData, payload as string);
  yield put(getBrandsAction(res?.data?.items || []));
  if (res?.data) {
    const { pageSize, totalPages, totalCount, pageIndex } = res?.data;
    yield put(setSizePageAction({ pageSize, totalPages, totalCount, pageIndex }));
  }
}

export function* getMoreBrandsWorkerSaga({ payload }: IAction<string>) {
  const res: IDataPage<IBrand[]> = yield call(getBrandsData, payload as string);
  yield put(getMoreBrandsAction(res?.data?.items || []));
  if (res?.data) {
    const { pageSize, totalPages, totalCount, pageIndex } = res?.data;
    yield put(setSizePageAction({ pageSize, totalPages, totalCount, pageIndex }));
  }
}

export function* getBrandWorkerSaga({ payload }: IAction<string>) {
  const res: IData<IBrand> = yield call(getBrand, payload as string);
  yield put(getBrandAction(res?.data));
}

export function* brandsWatcherSaga() {
  yield takeEvery(sagaTypes?.GET_ALL_BRANDS, getBrandsWorkerSaga);
  yield takeEvery(sagaTypes?.GET_MORE_BRANDS, getMoreBrandsWorkerSaga);
  yield takeEvery(sagaTypes?.GET_BRAND, getBrandWorkerSaga);
  yield takeEvery(sagaTypes?.GET_ALL_PUBLIC_BRANDS, getPublicBrandsWorkerSaga);
}

export function* getPublicBrandsWorkerSaga() {
  const res: IData<IBrand[]> = yield call(getBrands);
  yield put(getPublicBrandsAction(res.data || []));
}
